import { Situation } from '../model/situations';
import { Situation as SituationIntermediate } from '../structure/intermediates';

export default function convertSituationtoSituationIntermediate(situation:Situation): SituationIntermediate {

    const newSituation: SituationIntermediate = {
        ...situation,
        argumentList: []
    }

    const argumentMap = new Map<string,Map<string,Set<string>>>();

    situation.argumentList?.forEach((arg,idx) => {
        if(arg.role){
            if(!argumentMap.has(arg.role)){

                argumentMap.set(arg.role,new Map<string,Set<string>>());
                argumentMap.get(arg.role)?.set("entityId",new Set<string>());
                argumentMap.get(arg.role)?.set("situationId",new Set<string>());
            }

            // TODO: Handle property
            if (arg.entityId){
                // argumentMap.get(arg.role)?.add(arg.entityId?.uuidString)
                argumentMap.get(arg.role)!.get("entityId")?.add(arg.entityId.uuidString);
            } else if (arg.situationId){
                argumentMap.get(arg.role)!.get("entityId")?.add(arg.situationId.uuidString);
                // argumentMap.get(arg.role)?.add(arg.situationId?.uuidString)
            } else if (arg.propertyList) {
                const argument = {
                    role:arg.role,
                    propertyList:arg.propertyList
                }
                newSituation.argumentList!.push(argument);
            }
        }
    })

    argumentMap.forEach((value,role) => {
        const entityId = value.get("entityId");
        const situationId = value.get("situationId");

        if(entityId && entityId.size > 0){
            const argument = {
                role:role,
                entityId:entityId
            }
            newSituation.argumentList!.push(argument);
        }
        
        if(situationId && situationId.size > 0){
            const argument = {
                role:role,
                situationId:situationId
            }
            newSituation.argumentList!.push(argument);
        }

    })

    return newSituation
}